/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { AppService } from '../api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from './localstorage.service';

@Injectable({
  providedIn: 'root'
})
export class TrialService {
  isTrialExpire=false;

  constructor(private _as:AppService,private _router:Router,private _ac:ActivatedRoute,private localStorageService: LocalStorageService) { 
  }

  updateLocalStorage(data:any){
    const user_info = JSON.parse(this.localStorageService.getItem('user_info') || '{}');
    user_info.professional.is_subscribe=data.is_subscribe;
    this._as.user_info.professional.is_subscribe=data.is_subscribe;
    user_info.professional.is_trial_expire=data.is_trial_expire;
    this._as.user_info.professional.is_trial_expire=data.is_trial_expire;
    user_info.professional.is_trial=data.is_trial;
    this._as.user_info.professional.is_trial=data.is_trial;
    this.localStorageService.setItem('user_info',JSON.stringify(user_info));
    if(data.is_trial && !this.localStorageService.getItem('popup')){
      this.showTrialExpirePopup();
    }else if(data.is_subscribe){
      this.localStorageService.removeItem('popup');
    }
    console.log(Date.now())
  }
  showTrialExpirePopup(){
    this._router.navigate(
        [],
      {
        relativeTo: this._ac,
        queryParams: { isTrialExpire:true },
        queryParamsHandling: 'merge',
        replaceUrl:true
    });
    this.localStorageService.setItem('popup','true')
  }
}
